import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { Box, Chip, Grid, styled, Typography } from '@mui/material';
import React, { useState } from 'react';

import { highlightKeys } from '../../helper/KeywordHighlighter';
import WsColors from '../../WsColors';
import { WsButton } from '../WsButton';
import { WsTypoColors, WsTypoVariants } from '../WsTypography';

export enum ChipsType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
const mapColor = new Map();
mapColor.set('light', WsColors.TheBlues100);
mapColor.set('primary', WsColors.TheBlues50);
mapColor.set('secondary', WsColors.TertiaryShades100);
export interface WsTagsListProps {
  chipArray: string[];
  count: number;
  type: ChipsType;
  onDelete?: (chip: string) => void;
  allowDelete?: boolean;
  query?: string;
  borderColorFlag?: boolean;
  tagOnClick?: () => void;
  isKeyNotReq?: boolean;
}
export interface TagType {
  type: string;
  allowDelete: boolean;
}
const ChipStyle = styled(Chip)(({ type, allowDelete }: TagType) => ({
  borderRadius: 4,
  backgroundColor: mapColor.get(type),
  marginLeft: 4,
  marginTop: 4,
  paddingRight: allowDelete ? 0 : 8,
  paddingLeft: 3,
  userSelect: 'unset',
  '&:hover': {
    backgroundColor: mapColor.get(type),
  },
}));

const WsTagsList = ({
  chipArray,
  count,
  type = ChipsType.SECONDARY,
  onDelete = () => {},
  allowDelete = false,
  query,
  borderColorFlag = false,
  isKeyNotReq = true,
  tagOnClick = () => {},
}: WsTagsListProps) => {
  const [displayListLimit, setDisplayLimit] = useState(count);
  return (
    <Box>
      {chipArray.length > 0 && (
        <Grid container item xs={12}>
          {chipArray.slice(0, displayListLimit).map((chipName: string, index: number) => (
            <ChipStyle
              key={index}
              type={type}
              size={isKeyNotReq ? 'small' : 'medium'}
              onDelete={onDelete ? () => onDelete(chipName) : undefined}
              deleteIcon={allowDelete ? <ClearOutlinedIcon /> : <></>}
              label={
                <Typography
                  color={type == ChipsType.PRIMARY ? WsColors.TheBlues700 : WsTypoColors.SECONDARY}
                  variant={WsTypoVariants.BODY2}
                  sx={{
                    cursor: 'pointer',
                    fontSize: isKeyNotReq ? '12px' : '14px',
                    fontWeight: isKeyNotReq ? 400 : 800,
                  }}
                  dangerouslySetInnerHTML={{
                    __html: query ? highlightKeys(chipName, query ?? '') : chipName,
                  }}
                />
              }
              allowDelete={allowDelete}
              variant={borderColorFlag ? 'outlined' : undefined}
              sx={{
                borderColor: borderColorFlag
                  ? type == ChipsType.PRIMARY
                    ? WsColors.TheBlues300
                    : WsColors.Red
                  : undefined,
              }}
              onClick={() => borderColorFlag && tagOnClick()}
            />
          ))}
          {chipArray.length > count && (
            <WsButton
              variant="text"
              size={isKeyNotReq ? 'medium' : 'large'}
              onClick={() =>
                setDisplayLimit(displayListLimit == chipArray.length ? count : chipArray.length)
              }
            >
              {displayListLimit < chipArray.length
                ? `+ ${chipArray.length - displayListLimit}more`
                : 'show less'}
            </WsButton>
          )}
        </Grid>
      )}
    </Box>
  );
};
export default WsTagsList;
